/* VuurvastVoorThuis - maatwerk verzendklasse
   Kiest op basis van de Measurify-invoer (breedte, lengte, aantal) automatisch de
   variant "Verzendklasse" en verbergt die keuze voor de klant.
   Regels: mail Thom Schepens, 15 sep 2026. Geen afhankelijkheden.
   De rekenlogica is een pure functie en wordt lokaal getest (maatwerk/test.js). */
(function (root) {
  'use strict';

  /* ---------- Rekenlogica (geen DOM) ---------- */

  function pastOp(b, l, palletB, palletL) {
    return (b <= palletB && l <= palletL) || (b <= palletL && l <= palletB);
  }

  function gewichtKg(breedte, lengte, aantal, dikteMm, dichtheid) {
    return (breedte / 1000) * (lengte / 1000) * (dikteMm / 1000) * dichtheid * aantal;
  }

  /* Geeft { klasse, gewicht } of null bij ongeldige invoer. Afmetingen in mm. */
  function bepaalVerzendklasse(invoer) {
    var b = Number(invoer.breedte), l = Number(invoer.lengte), n = Number(invoer.aantal);
    var dikte = Number(invoer.dikteMm), dichtheid = Number(invoer.dichtheid);
    var geldig = [b, l, n, dikte, dichtheid].every(function (x) { return isFinite(x) && x > 0; });
    if (!geldig || n !== Math.floor(n)) return null;

    var kg = gewichtKg(b, l, n, dikte, dichtheid);
    var klasse;
    if (b <= 450 && l <= 450 && kg <= 20) klasse = 'Pakket 1';
    else if (b <= 450 && l <= 450 && kg <= 40) klasse = 'Pakket 2';
    else if (pastOp(b, l, 400, 600)) klasse = 'Kwartpallet';
    else if (pastOp(b, l, 600, 800)) klasse = 'Halvepallet';
    else klasse = 'Europallet';
    return { klasse: klasse, gewicht: kg };
  }

  var api = { bepaalVerzendklasse: bepaalVerzendklasse, gewichtKg: gewichtKg };
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; return; }
  root.VVTMaatwerk = api;
  if (typeof document === 'undefined') return;

  /* ---------- Koppeling met de pagina ---------- */

  if (root.__vvtMaatwerkGestart) return;          // nooit dubbel starten
  root.__vvtMaatwerkGestart = true;

  /* De sectie verbergt de keuze Verzendklasse al in de HTML. Lukt sturen niet, dan de keuze weer tonen. */
  function toonKeuze() {
    var s = document.getElementById('vvt-maatwerk-voorverbergen');
    if (s && s.parentNode) s.parentNode.removeChild(s);
    klaar();
  }

  /* De koopknop staat verborgen tot de pagina af is (zie product-form.liquid): dan in één keer tonen. */
  function klaar() { document.documentElement.classList.add('vvt-klaar'); }

  var configEl = document.getElementById('vvt-maatwerk-config');
  if (!configEl) { toonKeuze(); return; }
  var config;
  try { config = JSON.parse(configEl.textContent); } catch (e) { toonKeuze(); return; }

  var debug = !!config.debug || /[?&]vvtdebug=1/.test(root.location.search);
  function log() { if (debug && root.console) console.log.apply(console, ['[vvt-maatwerk]'].concat([].slice.call(arguments))); }

  /* Measurify leidt de veldnaam af van het label (Aantal platen -> aantal_platen). Wordt het label
     hernoemd, dan verandert de klasse mee. Daarom op een deel van de naam zoeken. */
  var SEL = {
    breedte: 'input[class*="pc-field-id-"][class*="_width"], [class*="pc-field-id-"][class*="_width"] input',
    lengte: 'input[class*="pc-field-id-"][class*="_height"], [class*="pc-field-id-"][class*="_height"] input',
    aantal: 'input[class*="pc-field-id-aantal"], [class*="pc-field-id-aantal"] input'
  };
  var FORM_PREFIX = 'product-form-main-';
  var actief = false;        // true zodra de keuze verborgen is en wij sturen
  var huidige = null;        // laatste geldige uitkomst { klasse, gewicht }

  function veld(naam) { return document.querySelector(SEL[naam]); }

  /* Dikte: keuzeknoppen in het rekenblok (veld met "dikte" in de naam, gekozen knop heeft klasse
     "selected", tekst zoals "30 mm"). Ontbreekt het veld, dan de vaste dikte uit de sectie-instelling. */
  var SEL_DIKTE = '[class*="pc-field-id-"][class*="dikte"]';
  function dikteMm() {
    var groep = document.querySelector(SEL_DIKTE);
    if (!groep) return config.dikteMm;
    var gekozen = groep.querySelector('.selected, [aria-checked="true"], input:checked');
    var tekst = gekozen ? (gekozen.value || gekozen.textContent || '') : '';
    var m = /(\d+(?:[.,]\d+)?)\s*mm/i.exec(tekst);
    return m ? parseFloat(m[1].replace(',', '.')) : null;   // veld aanwezig maar niets gekozen: ongeldig
  }

  function getal(el) {
    if (!el) return null;
    var v = parseFloat(String(el.value).replace(',', '.'));
    return isFinite(v) ? v : null;
  }

  function hoofdFormulier() {
    return document.querySelector('form[id^="' + FORM_PREFIX + '"]');
  }

  /* Niet form.id gebruiken: het formulier bevat een veld met name="id", dat form.id overschaduwt. */
  function formNaam(form) { return form.getAttribute('id'); }

  /* Keuzerondjes van de optie Verzendklasse die bij het hoofdformulier horen, per naam. */
  function rondjesPerKlasse() {
    var form = hoofdFormulier();
    var uit = {};
    if (!form) return uit;
    var rondjes = document.querySelectorAll('input[type="radio"][data-option-position][form="' + formNaam(form) + '"]');
    [].forEach.call(rondjes, function (r) {
      var label = r.id ? document.querySelector('label[for="' + r.id + '"]') : null;
      var naam = label ? label.textContent.replace(/\s+/g, ' ').trim() : '';
      if (naam) uit[naam] = r;
    });
    return uit;
  }

  function allesAanwezig() {
    if (!veld('breedte') || !veld('lengte') || !veld('aantal')) return false;
    var r = rondjesPerKlasse();
    return Object.keys(config.varianten).every(function (naam) { return !!r[naam]; });
  }

  function kiesKlasse(klasse) {
    var variantId = config.varianten[klasse];
    var form = hoofdFormulier();
    if (!variantId || !form) return false;

    // 1. Het id dat meegaat naar de winkelwagen direct goed zetten (ook tijdens het verversen van het thema).
    var idVelden = [].slice.call(document.querySelectorAll('input[name="id"][form="' + formNaam(form) + '"]'))
      .concat([].slice.call(form.querySelectorAll('input[name="id"]')));
    idVelden.forEach(function (el) { el.value = String(variantId); });

    // 2. De variantkiezer van het thema laten volgen.
    var rondje = rondjesPerKlasse()[klasse];
    if (rondje && !rondje.checked) {
      rondje.checked = true;
      rondje.dispatchEvent(new Event('change', { bubbles: true }));
      log('variant gekozen:', klasse, variantId);
    }
    return true;
  }

  var wisselTimer = null;

  function bijwerken(direct) {
    var uitkomst = bepaalVerzendklasse({
      breedte: getal(veld('breedte')),
      lengte: getal(veld('lengte')),
      aantal: getal(veld('aantal')),
      dikteMm: dikteMm(),
      dichtheid: config.dichtheid
    });
    huidige = uitkomst;
    if (actief) toonVerzend(uitkomst);
    if (!uitkomst) { log('invoer nog niet compleet'); return; }
    log(uitkomst.klasse, uitkomst.gewicht.toFixed(2) + ' kg');
    if (!actief) return;
    clearTimeout(wisselTimer);
    if (direct) kiesKlasse(uitkomst.klasse);
    else wisselTimer = setTimeout(function () { if (huidige) kiesKlasse(huidige.klasse); }, 300);
  }

  /* Het thema ververst na een wissel met een vertraagde server-aanvraag. Komt een oudere aanvraag
     later binnen dan een nieuwere, dan zet het thema de oude variant terug. Daarom na elke wissel
     controleren en zo nodig herstellen. Begrensd, zodat er nooit een lus ontstaat. */
  var herstelTijden = [];
  function naWissel(event) {
    if (!actief || !huidige) return;
    var gewenst = config.varianten[huidige.klasse];
    var gekregen = event.detail && event.detail.variant && event.detail.variant.id;
    if (!gewenst || String(gekregen) === String(gewenst)) return;
    var nu = Date.now();
    herstelTijden = herstelTijden.filter(function (t) { return nu - t < 3000; });
    if (herstelTijden.length >= 6) { log('herstel begrensd'); return; }
    herstelTijden.push(nu);
    setTimeout(function () { if (huidige) { log('herstel naar', huidige.klasse); kiesKlasse(huidige.klasse); } }, 0);
  }

  function toonMelding(tekst) {
    var el = document.getElementById('vvt-maatwerk-melding');
    if (!el) {
      el = document.createElement('p');
      el.id = 'vvt-maatwerk-melding';
      el.setAttribute('role', 'alert');
      el.style.cssText = 'margin:12px 0;color:#b3261e;font-size:14px';
      var anker = document.querySelector('.pc-calculator-widget');
      if (anker && anker.parentNode) anker.parentNode.insertBefore(el, anker.nextSibling);
      else return;
    }
    el.textContent = tekst;
    el.hidden = !tekst;
  }

  /* Bestellen tegenhouden zolang de invoer ongeldig is. Alleen als wij sturen. */
  function bewaak(event) {
    if (!actief) return;
    var form = hoofdFormulier();
    if (!form) return;
    var doel = event.target;
    var hoortBijForm = event.type === 'submit'
      ? doel === form
      : !!(doel.closest && doel.closest('button[type="submit"], input[type="submit"]')) &&
        (function (knop) { return knop.form === form || knop.getAttribute('form') === formNaam(form); })(doel.closest('button[type="submit"], input[type="submit"]'));
    if (!hoortBijForm) return;

    bijwerken(true);
    if (!huidige) {
      event.preventDefault();
      event.stopImmediatePropagation();
      toonMelding(config.meldingOngeldig);
      return;
    }
    toonMelding('');
    kiesKlasse(huidige.klasse);
    markeerRegel(form);
  }

  /* Shopify voegt twee keer dezelfde maat samen tot een regel met aantal 2. Elke plaat moet een eigen regel
     zijn (aantal staat vast op 1, zie mini-cart en main-cart). Daarom per toevoeging een uniek, verborgen
     kenmerk meegeven; eigenschappen die met _ beginnen toont het thema niet. */
  function markeerRegel(form) {
    var el = form.querySelector('input[name="properties[_plaat]"]');
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = 'properties[_plaat]';
      form.appendChild(el);
    }
    el.value = Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
  }

  /* ---------- Weergave: prijs verbergen, label vervangen, verzendkosten tonen ---------- */

  function euro(bedrag) {
    return '\u20ac ' + Number(bedrag).toFixed(2).replace('.', ',');
  }

  /* Measurify toont de oppervlakte als "Toplam Alan" (Turks) en dat is in de app niet aan te passen.
     Alleen de tekst vervangen; Measurify zet hem bij elke herberekening opnieuw, dus blijven kijken. */
  function vervangLabel() {
    var label = config.oppervlakteLabel;
    if (!label) return;
    [].forEach.call(document.querySelectorAll('.pc-dim-area'), function (el) {
      [].forEach.call(el.childNodes, function (n) {
        if (n.nodeType === 3 && n.nodeValue.indexOf('Toplam Alan') !== -1) n.nodeValue = n.nodeValue.replace('Toplam Alan', label);
      });
    });
  }

  /* Verzendkosten voor de gekozen klasse, onder het Measurify-blok en boven de knop. Staat buiten het
     blok van Measurify (dat door React beheerd wordt) en buiten de blokken die het thema ververst. */
  function verzendElement() {
    var el = document.getElementById('vvt-maatwerk-verzend');
    if (el) return el;
    var widget = document.querySelector('.pc-calculator-widget');
    if (!widget) return null;
    var anker = widget.closest('.shopify-app-block') || widget;
    el = document.createElement('div');
    el.id = 'vvt-maatwerk-verzend';
    el.hidden = true;
    el.innerHTML =
      '<div class="vvt-verzend__rij"><span class="vvt-verzend__label"></span><span class="vvt-verzend__bedrag"></span></div>' +
      '<p class="vvt-verzend__sub"></p>';
    anker.parentNode.insertBefore(el, anker.nextSibling);
    return el;
  }

  function toonVerzend(uitkomst) {
    if (!config.toonVerzend) return;
    var el = verzendElement();
    if (!el) return;
    var land = config.land || 'NL';
    var tarieven = (config.tarieven && config.tarieven[land]) || null;
    var ruw = uitkomst && tarieven ? tarieven[uitkomst.klasse] : null;
    var bedrag = ruw === null || ruw === undefined ? NaN : parseFloat(String(ruw).replace(',', '.'));
    if (!isFinite(bedrag)) { el.hidden = true; return; }
    el.querySelector('.vvt-verzend__label').textContent = config.verzendLabel || 'Verzendkosten';
    el.querySelector('.vvt-verzend__bedrag').textContent = euro(bedrag);
    var sub = el.querySelector('.vvt-verzend__sub');
    sub.textContent = config.verzendSubtekst || '';
    sub.hidden = !config.verzendSubtekst;
    el.hidden = false;
  }

  /* ---------- Akkoord met de maatwerkvoorwaarden (verplicht vinkje) ---------- */

  function akkoordElement() {
    var el = document.getElementById('vvt-maatwerk-akkoord');
    if (el || !config.akkoord) return el;
    var widget = document.querySelector('.pc-calculator-widget');
    if (!widget) return null;
    var anker = document.getElementById('vvt-maatwerk-verzend') || widget.closest('.shopify-app-block') || widget;
    el = document.createElement('div');
    el.id = 'vvt-maatwerk-akkoord';
    var label = document.createElement('label');
    label.className = 'vvt-akkoord__label';
    var vink = document.createElement('input');
    vink.type = 'checkbox';
    vink.id = 'vvt-maatwerk-akkoord-vink';
    label.appendChild(vink);
    var tekst = document.createElement('span');   // tekst en link samen, anders zet de flexrij er ruimte tussen
    tekst.appendChild(document.createTextNode((config.akkoordTekst || 'Ik ga akkoord met de') + ' '));
    var link = document.createElement('a');
    /* Standaard: het terugbetalingsbeleid, geopend bij de alinea Maatwerkproducten via een tekstfragment
       (de kop heeft geen anker). Browsers zonder ondersteuning openen de pagina bovenaan. */
    link.href = config.akkoordUrl || '/policies/refund-policy#:~:text=Maatwerkproducten,geen%20herroepingsrecht';
    link.target = '_blank';
    link.rel = 'noopener';
    link.textContent = config.akkoordLinkTekst || 'voorwaarden en levertijd voor maatwerkproducten';
    tekst.appendChild(link);
    label.appendChild(tekst);
    var melding = document.createElement('p');
    melding.className = 'vvt-akkoord__melding';
    melding.setAttribute('role', 'alert');
    melding.hidden = true;
    el.appendChild(label);
    el.appendChild(melding);
    anker.parentNode.insertBefore(el, anker.nextSibling);
    vink.addEventListener('change', function () { if (vink.checked) toonAkkoordMelding(''); });
    return el;
  }

  /* ---------- Grote aantallen of afwijkende maat: mail met de ingevulde gegevens ---------- */

  function mailHref() {
    var d = dikteMm(), b = getal(veld('breedte')), l = getal(veld('lengte')), n = getal(veld('aantal'));
    /* Tekst van Thom (mail 24 sep 2026). Wat de klant al heeft ingevuld, staat er meteen achter. */
    var regels = [
      'Hallo,',
      'Ik wil graag een aanvraag doen voor vermiculiet op maat.',
      '',
      'Dikte: ' + (d ? d + ' mm' : ''),
      '',
      'Aantal stuks/platen: ' + (n || ''),
      '',
      'Gewenste maatvoering / vorm: ' + (b && l ? b + ' x ' + l + ' mm' : ''),
      '',
      'Beschrijf hieronder de gewenste afmetingen. Gaat het om een afwijkende vorm of meerdere verschillende maten? ' +
        'Voeg dan bij voorkeur een schets, tekening of duidelijke foto en afmetingen toe.',
      '', '',
      'Aanvullende informatie:',
      '', '',
      'Op basis van deze gegevens ontvang ik graag een prijsopgave.',
      ''
    ];
    return 'mailto:' + (config.mailAdres || 'info@vuurvastvoorthuis.nl') +
      '?subject=' + encodeURIComponent((config.mailOnderwerp || 'Aanvraag maatwerk') + ': ' + (config.product || '')) +
      '&body=' + encodeURIComponent(regels.join('\n'));
  }

  function mailElement() {
    var el = document.getElementById('vvt-maatwerk-mail');
    if (el || !config.mail) return el;
    /* Direct onder de koopknop, zodat het vinkje boven de knop blijft staan. Ververst het thema de knop
       bij een variantwissel, dan zet start() de regel opnieuw neer (zie variant:changed). */
    var form = hoofdFormulier();
    var anker = document.querySelector('#AddToCart[form="' + (form && formNaam(form)) + '"]') ||
      (form && form.querySelector('#AddToCart')) || document.querySelector('.product-form__buy-buttons #AddToCart') ||
      document.getElementById('vvt-maatwerk-akkoord') || document.getElementById('vvt-maatwerk-verzend');
    if (!anker) {
      var widget = document.querySelector('.pc-calculator-widget');
      if (!widget) return null;
      anker = widget.closest('.shopify-app-block') || widget;
    }
    el = document.createElement('p');
    el.id = 'vvt-maatwerk-mail';
    el.appendChild(document.createTextNode((config.mailTekst || 'Meer dan 20 platen of een afwijkende maat nodig?') + ' '));
    var link = document.createElement('a');
    link.href = mailHref();
    link.textContent = config.mailLinkTekst || 'Mail ons je aanvraag';
    // Pas bij de klik invullen: dan staan de maten er zoals de klant ze nu heeft ingevuld.
    link.addEventListener('click', function () { link.href = mailHref(); });
    el.appendChild(link);
    anker.parentNode.insertBefore(el, anker.nextSibling);
    return el;
  }

  function toonAkkoordMelding(tekst) {
    var el = document.getElementById('vvt-maatwerk-akkoord');
    if (!el) return;
    var m = el.querySelector('.vvt-akkoord__melding');
    m.textContent = tekst;
    m.hidden = !tekst;
  }

  function akkoordGegeven() {
    if (!config.akkoord) return true;
    var vink = document.getElementById('vvt-maatwerk-akkoord-vink');
    return !!(vink && vink.checked);
  }

  /* Het akkoord als eigenschap op de bestelregel meegeven, zodat het bij de bestelling staat. */
  function zetAkkoordEigenschap(form) {
    var naam = config.akkoordEigenschap;
    if (!naam) return;
    var el = form.querySelector('input[name="properties[' + naam + ']"]');
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = 'properties[' + naam + ']';
      form.appendChild(el);
    }
    el.value = 'Akkoord';
  }

  /* Measurify behandelt een klik op elke verzendknop als "in winkelwagen". Hoort de knop niet bij een
     toevoegformulier (zoals "Naar afrekenen" in de winkelwagenlade), dan valt Measurify terug op het
     eerste toevoegformulier in de pagina, voegt dat product toe en houdt het afrekenen tegen.
     Daarom zulke klikken hier afschermen: window vangt eerder dan document, dus Measurify ziet ze niet.
     Geen preventDefault: de browser verstuurt het eigen formulier van de knop gewoon.

     Tweede geval: Measurify zet de maten en _calc_price ook in ANDERE toevoegformulieren op de pagina
     (aanbevolen producten in de winkelwagenlade). Zo'n product zou met de maatwerkprijs in de wagen komen.
     Daar de ingespoten velden weghalen en het formulier markeren als "al verwerkt"; Measurify laat het dan
     met rust (vlag pricecalcProcessed uit calculator.js, versie 289) en het thema voegt gewoon toe. */
  function schermAf(event) {
    var doel = event.target, form;
    if (event.type === 'submit') form = doel;
    else {
      var knop = doel && doel.closest && doel.closest('button[type="submit"], input[type="submit"]');
      form = knop && knop.form;
    }
    if (!form || !form.getAttribute) return;
    var actie = form.getAttribute('action') || '';

    if (actie.indexOf('/cart/add') === -1) {
      if (event.type !== 'click') return;
      event.stopImmediatePropagation();
      log('klik afgeschermd voor Measurify:', actie);
      return;
    }
    if (form === hoofdFormulier()) {
      if (actief && !akkoordGegeven()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        toonAkkoordMelding(config.akkoordMelding || 'Vink eerst aan dat je akkoord gaat met de voorwaarden.');
        var vink = document.getElementById('vvt-maatwerk-akkoord-vink');
        if (vink) vink.focus();
        log('toevoegen tegengehouden: geen akkoord');
        return;
      }
      if (actief) { markeerRegel(form); zetAkkoordEigenschap(form); }   // window-capture: voor Measurify het formulier uitleest
      /* Derde geval: een knop van het hoofdformulier die er BUITEN staat (plakbalk, gekoppeld met form="...").
         Ook daar valt Measurify terug op het eerste toevoegformulier in de pagina. Daarom de klik doorzetten
         naar de knop IN het formulier, zodat alles de gewone weg volgt. */
      if (event.type === 'click' && knop && !form.contains(knop)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var hoofdknop = form.querySelector('button[type="submit"], input[type="submit"]');
        log('klik van knop buiten het formulier doorgezet');
        if (hoofdknop) hoofdknop.click();
        else if (form.requestSubmit) form.requestSubmit();
      }
      return;
    }

    [].forEach.call(form.querySelectorAll('.pc-injected-property'), function (el) { el.parentNode.removeChild(el); });
    form.dataset.pricecalcProcessed = 'true';
    log('ander toevoegformulier: maatwerkvelden verwijderd', form.getAttribute('id'));
  }

  function activeer() {
    if (actief) return;
    actief = true;
    var stijl = document.createElement('style');
    stijl.id = 'vvt-maatwerk-stijl';
    stijl.textContent =
      '.vvt-maatwerk-actief [data-block-type="variant-picker"],' +
      '.vvt-maatwerk-actief .product-sticky-form__variants{display:none !important}' +
      /* Ondergeschikt aan het kader "Totale prijs" van Measurify: geen kader, kleiner, grijzer. */
      '#vvt-maatwerk-verzend{margin:-6px 0 10px;padding:0 20px;color:#666}' +
      '#vvt-maatwerk-verzend .vvt-verzend__rij{display:flex;justify-content:space-between;align-items:baseline;' +
        'font-size:13px;line-height:20px}' +
      '#vvt-maatwerk-verzend .vvt-verzend__bedrag{font-size:14px;font-weight:600;color:#000}' +
      '#vvt-maatwerk-verzend .vvt-verzend__sub{margin:0;font-size:11px;line-height:16px;opacity:.75}' +
      '#vvt-maatwerk-akkoord{margin:0;font-size:13px;line-height:20px}' +
      '#vvt-maatwerk-akkoord .vvt-akkoord__label{display:flex;gap:10px;align-items:center;cursor:pointer}' +
      '#vvt-maatwerk-akkoord input{margin:0;width:16px;height:16px;flex:0 0 auto;accent-color:#71dc31}' +
      '#vvt-maatwerk-akkoord .vvt-akkoord__label > span{line-height:16px}' +
      '#vvt-maatwerk-akkoord a{text-decoration:underline}' +
      '#vvt-maatwerk-akkoord .vvt-akkoord__melding{margin:6px 0 0 26px;color:#b3261e;font-size:13px}' +
      '#vvt-maatwerk-mail{margin:12px 0 0;font-size:13px;line-height:20px;color:#666}' +
      '#vvt-maatwerk-mail a{color:#000;font-weight:600;text-decoration:underline}';
    document.head.appendChild(stijl);
    document.documentElement.classList.add('vvt-maatwerk-actief');
    log('actief: keuze verborgen');
    vervangLabel();
    var widget = document.querySelector('.pc-calculator-widget');
    if (widget) new MutationObserver(vervangLabel).observe(widget, { childList: true, characterData: true, subtree: true });
    bijwerken(true);
    verzendElement();
    akkoordElement();
    mailElement();
    klaar();
  }

  /* ---------- Alleen hele millimeters en hele aantallen (feedback Thom, 5 okt 2026) ----------
     Measurify heeft er geen instelling voor: komma en punt tegenhouden, telefoon het cijfertoetsenbord
     geven en een geplakte of toch ingevoerde decimaal bij het verlaten van het veld afronden. */
  var SEL_HEEL = [SEL.breedte, SEL.lengte, SEL.aantal].join(', ');

  function heelVeld(el) { return !!(el && el.matches && el.matches(SEL_HEEL)); }

  function zetHeelAttributen(el) {
    if (el.getAttribute('step') !== '1') el.setAttribute('step', '1');
    if (el.getAttribute('inputmode') !== 'numeric') el.setAttribute('inputmode', 'numeric');
  }

  function rondAf(el) {
    var v = getal(el);
    if (v === null || v === Math.round(v)) return;
    /* Measurify is React: via de setter van het prototype, anders negeert React de nieuwe waarde. */
    Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set.call(el, String(Math.round(v)));
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
    log('afgerond naar heel getal', el.className, el.value);
  }

  /* Niet boven het maximum dat Measurify op het veld zet (breedte 610, lengte 1000; aantal heeft er geen).
     Tijdens het typen terugzetten naar het maximum. Dit loopt in de capture-fase, vóór React het
     input-event leest, dus Measurify rekent direct met de begrensde waarde. Het minimum niet: dan zou
     de eerste cijfer van 300 al geweigerd worden. */
  function begrensMax(el) {
    var max = parseFloat(el.getAttribute('max'));
    var v = getal(el);
    if (!isFinite(max) || v === null || v <= max) return;
    Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set.call(el, String(max));
    log('begrensd op maximum', el.className, max);
  }

  function alleenHeleGetallen() {
    document.addEventListener('input', function (event) {
      if (heelVeld(event.target)) begrensMax(event.target);
    }, true);
    [].forEach.call(document.querySelectorAll(SEL_HEEL), zetHeelAttributen);
    document.addEventListener('focusin', function (event) {
      if (heelVeld(event.target)) zetHeelAttributen(event.target);
    }, true);
    document.addEventListener('keydown', function (event) {
      if (heelVeld(event.target) && /^[.,eE+\-]$/.test(event.key)) event.preventDefault();
    }, true);
    document.addEventListener('change', function (event) {
      if (heelVeld(event.target)) rondAf(event.target);
    }, true);
    document.addEventListener('focusout', function (event) {
      if (heelVeld(event.target)) rondAf(event.target);
    }, true);
  }

  function start() {
    alleenHeleGetallen();
    // Luisteren kan meteen; sturen pas als alles gevonden is.
    ['input', 'change'].forEach(function (type) {
      document.addEventListener(type, function (event) {
        var t = event.target;
        if (t && t.matches && (t.matches(SEL.breedte) || t.matches(SEL.lengte) || t.matches(SEL.aantal))) bijwerken(false);
      }, true);
    });
    root.addEventListener('click', schermAf, true);
    root.addEventListener('submit', schermAf, true);
    document.addEventListener('click', function (event) {
      var t = event.target;
      if (t && t.closest && t.closest(SEL_DIKTE)) setTimeout(function () { bijwerken(false); }, 0);
    }, true);
    document.addEventListener('variant:changed', naWissel);
    document.addEventListener('variant:changed', function () { if (actief) setTimeout(mailElement, 50); });
    document.addEventListener('submit', bewaak, true);
    document.addEventListener('click', bewaak, true);

    if (allesAanwezig()) { activeer(); return; }

    // Measurify bouwt zijn velden later op: wachten tot ze er zijn, maximaal 20 seconden.
    var waarnemer = new MutationObserver(function () {
      if (allesAanwezig()) { waarnemer.disconnect(); activeer(); }
    });
    waarnemer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () {
      waarnemer.disconnect();
      if (!actief) { toonKeuze(); log('velden niet gevonden: keuze weer zichtbaar (vangnet)'); }
    }, 20000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})(typeof window !== 'undefined' ? window : this);
